import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-7",
  style: {"background":"#1c325e"}
}
const _hoisted_2 = { class: "card-body d-flex" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "position-relative fs-2x z-index-2 fw-bolder text-danger mb-7" }
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("API ")
const _hoisted_7 = { class: "position-relative d-inline-block text-danger" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "position-absolute opacity-50 bottom-0 start-0 border-4 border-danger border-bottom w-100" }, null, -1)
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "position-relative w-md-400px me-md-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "black"
    })
  ])
], -1)
const _hoisted_12 = { class: "d-flex align-items-center my-2" }
const _hoisted_13 = { class: "w-140px me-5" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<option value=\"All\">Filter</option><option value=\"Processor\">Processors</option><option value=\"Gateway\">Gateways</option><option value=\"Crm\">CRMs</option><option value=\"Portal\">Portals</option>", 5)
const _hoisted_19 = [
  _hoisted_14
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    id: "kt_horizontal_search_advanced_link",
    class: "btn btn-link",
    "data-bs-toggle": "collapse",
    href: "#kt_advanced_search_form"
  }, "Advanced Search")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: "/metronic8/demo3/assets/media/illustrations/sigma-1/17-dark.png",
  class: "position-absolute me-3 bottom-0 end-0 h-200px",
  alt: ""
}, null, -1)
const _hoisted_22 = {
  class: "collapse card p-5 mb-5",
  id: "kt_advanced_search_form"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, null, -1)
const _hoisted_24 = { class: "row g-8" }
const _hoisted_25 = { class: "col-lg-3 col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "ID", -1)
const _hoisted_27 = { class: "col-lg-3 col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Connection ID", -1)
const _hoisted_29 = { class: "col-lg-3 col-md-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Customer ID", -1)
const _hoisted_31 = { class: "col-lg-3 col-md-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Endpoint ID", -1)
const _hoisted_33 = { class: "col-lg-3 col-md-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Endpoint Name", -1)
const _hoisted_35 = { class: "col-lg-3 col-md-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Endpoint Path", -1)
const _hoisted_37 = { class: "col-lg-3 col-md-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 form-label fw-bolder text-dark" }, "Merchant ID", -1)
const _hoisted_39 = { class: "card h-90" }
const _hoisted_40 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5 align-middle"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "d-flex flex-stack flex-wrap pt-10" }
const _hoisted_44 = { class: "fs-6 fw-bold text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantApiCard = _resolveComponent("MerchantApiCard")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_UpdateApiDrawer = _resolveComponent("UpdateApiDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToOverview())),
                  class: "text-white opacity-75-hover"
                }, "Connections"),
                _hoisted_8
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid ps-10",
                name: "search",
                placeholder: "Search",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParam.search) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParam.search]
              ])
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary me-5",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
            }, " Search "),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("select", {
                  name: "status",
                  "data-control": "select2",
                  "data-hide-search": "true",
                  class: "form-select form-select-white form-select-sm",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedGroup) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selGroup && _ctx.selGroup(...args)))
                }, _hoisted_19, 544), [
                  [_vModelSelect, _ctx.selectedGroup]
                ])
              ])
            ])
          ]),
          _hoisted_20
        ]),
        _hoisted_21
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control form-control-solid",
            name: "id",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParam.id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchParam.id]
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control form-control-solid",
            name: "connection_id",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchParam.connection_id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchParam.connection_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control form-control-solid",
            name: "customer_id",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchParam.customer_id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchParam.customer_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control form-control-solid",
            name: "endpoint_id",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchParam.endpoint_id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchParam.endpoint_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control form-control-solid",
            name: "endpoint_name",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchParam.endpoint_name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchParam.endpoint_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control form-control-solid",
            name: "endpoint_path",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchParam.endpoint_path) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchParam.endpoint_path]
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control form-control-solid",
            name: "merchant_id",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchParam.merchant_id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchParam.merchant_id]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["row g-6 g-xl-9", [_ctx.loading && 'overlay overlay-block']])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apis, (api, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-sm-6 col-xl-4",
          key: index
        }, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_MerchantApiCard, {
              "card-classes": "h-90",
              icon: api.connection.logo_url,
              endpointDomain: api.connection.domain,
              connName: api.connection.conn_name,
              color: "success",
              arrow: "Up-right",
              endpointName: api.endpoint_name,
              endpointStatus: api.endpoint.endpoint_status,
              "footer-text": "/transactions/query?",
              indicatorValue: api.connection.category,
              indicatorLabel: api.endpoint.endpoint_path,
              isWarning: api.endpoint_status !== 'Active',
              api: api,
              apiId: api.id,
              aliasName: api.alias_name,
              onEdit: _ctx.editAPI,
              onRefresh: _ctx.getApis
            }, null, 8, ["icon", "endpointDomain", "connName", "endpointName", "endpointStatus", "indicatorValue", "indicatorLabel", "isWarning", "api", "apiId", "aliasName", "onEdit", "onRefresh"])
          ])
        ]))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, " Showing " + _toDisplayString((_ctx.curPage - 1) * _ctx.rowsPerPage + 1) + " to " + _toDisplayString((_ctx.curPage - 1) * _ctx.rowsPerPage + _ctx.curRows) + " of " + _toDisplayString(_ctx.total) + " entries ", 1),
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.curPage,
          "onUpdate:current-page": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.curPage) = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.rowsPerPage,
          layout: "prev, pager, next",
          total: _ctx.total,
          "hide-on-single-page": false,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
      ])
    ]),
    _createVNode(_component_UpdateApiDrawer, {
      api: _ctx.selectedApi,
      procs: _ctx.procs,
      onSubmit: _ctx.onUpdateApiSubmit
    }, null, 8, ["api", "procs", "onSubmit"])
  ], 64))
}